<template>
    <label class="ui-switch" :class="{
        checked: innerValue,
        disabled,
        labeled: !!label,
    }">
        <input
            :id="id"
            type="checkbox"
            :disabled="disabled"
            v-model="innerValue"
        >
        <div class="ui-switch-other">
            <div class="ui-switch-track"></div>
            <div class="ui-switch-thumb"></div>
            <div class="ui-switch-focus-ring"></div>
        </div>
        {{ label }}
    </label>
</template>

<script>
export default {
    name: 'ModelSwitch',
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            default: null,
        },
        inputValue: {
            type: [Boolean, Object, Array],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'input-value',
        event: 'change',
    },
    data() {
        return {
            id: null,
        };
    },
    computed: {
        isBoolean() {
            return this.value === true
                || this.value === false
                || this.value === null;
        },
        innerValue: {
            get() {
                if (Array.isArray(this.inputValue)) {
                    return this.inputValue.some(v => v === this.value);
                }
                return !!this.inputValue;
            },
            set(v) {
                if (this.disabled) return;
                let newValue;
                if (Array.isArray(this.inputValue)) {
                    let index = this.inputValue.indexOf(this.value);
                    let newValue = this.inputValue.slice();
                    if (index > -1) {
                        newValue.splice(index, 1);
                    } else {
                        newValue.push(this.value);
                    }
                } else if (this.isBoolean) {
                    newValue = !this.inputValue;
                } else {
                    newValue = this.inputValue ? null : this.inputValue;
                }
                this.$emit('change', newValue);
            },
        },
    },
    mounted() {
        this.id = 'input-' + this._uid;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mt';

.ui-switch {
    margin-bottom: rem(22);
    display: flex;
    font-size: rem(18);
    line-height: rem(26);
    align-items: center;
    cursor: pointer;

    &.disabled {
        color: #2a2626;
        opacity: 0.4;
        cursor: default;
    }

    @include on-mobile {
        margin-bottom: mrem(22);
        font-size: mrem(18);
        line-height: mrem(26);
    }

    &.checked {
        .ui-switch-track {
            background-color: #9BB9EF;
        }

        .ui-switch-thumb {
            left: rem(14);
            background-color: #4663AB;

            @include on-mobile {
                left: mrem(14);
            }
        }

        .ui-switch-focus-ring {
            left: rem(3);
            background-color: #9BB9EF;

            @include on-mobile {
                left: mrem(3);
            }
        }
    }

    input {
        display: none;
    }
}

.ui-switch-other {
    position: relative;
    margin-right: rem(16);
    width: rem(32);
    height: rem(17);

    @include on-mobile {
        margin-right: mrem(16);
        width: mrem(24);
        height: mrem(17);
    }
}

.ui-switch-track {
    position: absolute;
    top: rem(3);
    width: rem(29);
    height: rem(12);
    background-color: #D2D5D9;
    border-radius: rem(8);
    transition: background-color 0.1s linear;

    @include on-mobile {
        top: mrem(3);
        width: mrem(29);
        height: mrem(12);
        border-radius: mrem(8);
    }
}

.ui-switch-thumb {
    position: absolute;
    top: 0;
    left: 0;
    width: rem(17);
    height: rem(17);
    border-radius: 50%;
    background-color: #FAFAFA;
    box-shadow: 0 0 rem(2) rgba(0, 0, 0, 0.12), 0 rem(2) rem(2) rgba(0, 0, 0, 0.237602);
    transition: all 0.2s ease;

    @include on-mobile {
        width: mrem(17);
        height: mrem(17);
        box-shadow: 0 0 mrem(2) rgba(0, 0, 0, 0.12), 0 mrem(2) mrem(2) rgba(0, 0, 0, 0.237602);
    }
}

.ui-switch-focus-ring {
    position: absolute;
    top: - rem(11);
    left: - rem(11);
    z-index: -1;
    border-radius: 50%;
    width: rem(42);
    height: rem(42);
    background-color: rgba(black, 0.1);
    transform: scale(0);
    opacity: 0;
    transition: all 0.2s ease;

    @include on-mobile {
        top: - rem(11);
        left: - rem(11);
        width: rem(42);
        height: rem(42);
    }
}
</style>
